import React from 'react';
import {GetServerSideProps} from 'next';
import {PageCategoryComp, ssrCategory} from '@graphql/generated/page';

import BackBar from '@components/Layout/BackBar';
import SearchDeliveryOption from '@components/Search/SearchDeliveryOption';
import SearchStores from '@components/Search/SearchStores';

export const getServerSideProps: GetServerSideProps = async ctx => {
  const {id} = ctx.query;
  const {
    props: {data},
  } = await ssrCategory.getServerPage({variables: {id: id as string}}, ctx);

  return {props: {data}};
};

const Category: PageCategoryComp = ({
  data: {
    category: {id: categoryId, name},
  },
}) => {
  return (
    <main>
      <section className="sticky top-0 left-0 right-0 max-w-md mx-auto bg-white z-70">
        <BackBar fallbackUrl="/search" alignment="justify-center">
          <p className="poppins-medium">{name}</p>
        </BackBar>
        <SearchDeliveryOption />
      </section>

      <section>
        <SearchStores categoryId={categoryId} />
      </section>
    </main>
  );
};

export default Category;
